var React = require('react');

function ToteBagXxl (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.5 9h19l-.7 11.2a1 1 0 0 1-1 .8H4.2a1 1 0 0 1-1-.8z","key":0}),React.createElement("path",{"d":"M8 9V6.5a4 4 0 0 1 8 0V9","key":1}),React.createElement("path",{"d":"M8 15h8","key":2}),React.createElement("path",{"d":"M10 13l-2 2 2 2","key":3}),React.createElement("path",{"d":"M14 13l2 2-2 2","key":4})]);
}

ToteBagXxl.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = ToteBagXxl;

ToteBagXxl.default = ToteBagXxl;
